(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["loader"] = factory(require("vue"));
	else
		root["loader"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__203__) {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 620:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

/***/ }),

/***/ 203:
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__203__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(203);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loader.vue?vue&type=template&id=1a3e84c0

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDynamicComponent)($props.name), {
    object: $props.object,
    color1: $props.color1,
    color2: $props.color2,
    loadingText: $props.loadingText,
    textColor: $props.textColor,
    textSize: $props.textSize,
    textWeight: $props.textWeight,
    size: $props.size,
    speed: $props.speed,
    bg: $props.bg,
    objectbg: $props.objectbg,
    opacity: $props.opacity,
    disableScrolling: $props.disableScrolling
  }, null, 8, ["object", "color1", "color2", "loadingText", "textColor", "textSize", "textWeight", "size", "speed", "bg", "objectbg", "opacity", "disableScrolling"]))]);
}
;// CONCATENATED MODULE: ./src/components/loader.vue?vue&type=template&id=1a3e84c0

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/loader1.vue?vue&type=template&id=74db59a1

const _hoisted_1 = {
  class: "load-text"
};
function loader1vue_type_template_id_74db59a1_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    id: "overlay-spinner",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'background-color': $data.bgcolors
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.loadingText), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "loader-spinner",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'border': $props.size + 'px solid ' + $props.objectbg,
      'border-top': $props.size + 'px solid ' + $props.object
    })
  }, null, 4)], 4);
}
;// CONCATENATED MODULE: ./src/components/loaders/loader1.vue?vue&type=template&id=74db59a1

;// CONCATENATED MODULE: ./src/mixins/overflow.js
/* harmony default export */ var overflow = ({
  mounted() {
    if (this.disableScrolling) {
      document.body.classList.add("overflowHidden");
    }
  },
  unmounted() {
    if (this.disableScrolling) {
      document.body.classList.remove("overflowHidden");
    }
  }
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/loader1.vue?vue&type=script&lang=js

/* harmony default export */ var loader1vue_type_script_lang_js = ({
  name: "static-loader",
  mixins: [overflow],
  props: {
    object: {
      type: String
    },
    color1: {
      type: String
    },
    color2: {
      type: String
    },
    loadingText: {
      type: String
    },
    textColor: {
      type: String
    },
    textSize: {
      type: [String, Number]
    },
    textWeight: {
      type: [String, Number]
    },
    size: {
      type: [String, Number]
    },
    speed: {
      type: [String, Number]
    },
    opacity: {
      type: [String, Number]
    },
    bg: {
      type: String
    },
    objectbg: {
      type: String
    },
    disableScrolling: {
      type: Boolean
    }
  },
  data() {
    return {
      bgcolors: ''
    };
  },
  created() {
    let root = document.documentElement;
    root.style.setProperty('--time-animation', "spin " + this.speed + "s linear infinite");
    root.style.setProperty('--load-text-color', this.textColor);
    root.style.setProperty('--load-text-size', this.textSize + 'px');
    root.style.setProperty('--load-text-weight', this.textWeight);
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(this.bg)) {
      let c = this.bg.substring(1).split('');
      if (c.length == 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      c = '0x' + c.join('');
      this.bgcolors = 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',' + this.opacity / 100 + ')';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/loaders/loader1.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/loader1.vue?vue&type=style&index=0&id=74db59a1&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/loaders/loader1.vue?vue&type=style&index=0&id=74db59a1&lang=css

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(620);
;// CONCATENATED MODULE: ./src/components/loaders/loader1.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(loader1vue_type_script_lang_js, [['render',loader1vue_type_template_id_74db59a1_render]])

/* harmony default export */ var loader1 = (__exports__);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/dots.vue?vue&type=template&id=5b0e5f43

function dotsvue_type_template_id_5b0e5f43_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    id: "overlay-dots",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'background-color': $data.bgcolors
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "loader-dots",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'color': $props.object,
      'font-size': $props.size + 'px'
    })
  }, null, 4)], 4);
}
;// CONCATENATED MODULE: ./src/components/loaders/dots.vue?vue&type=template&id=5b0e5f43

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/dots.vue?vue&type=script&lang=js

/* harmony default export */ var dotsvue_type_script_lang_js = ({
  name: "dots",
  mixins: [overflow],
  props: {
    object: {
      type: String
    },
    color1: {
      type: String
    },
    color2: {
      type: String
    },
    loadingText: {
      type: String
    },
    textColor: {
      type: String
    },
    textSize: {
      type: [String, Number]
    },
    textWeight: {
      type: [String, Number]
    },
    size: {
      type: [String, Number]
    },
    speed: {
      type: [String, Number]
    },
    opacity: {
      type: [String, Number]
    },
    bg: {
      type: String
    },
    objectbg: {
      type: String
    },
    disableScrolling: {
      type: Boolean
    }
  },
  data() {
    return {
      bgcolors: ''
    };
  },
  created() {
    let root = document.documentElement;
    root.style.setProperty('--time-animation', "load7 " + this.speed + "s infinite ease-in-out");
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(this.bg)) {
      let c = this.bg.substring(1).split('');
      if (c.length == 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      c = '0x' + c.join('');
      this.bgcolors = 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',' + this.opacity / 100 + ')';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/loaders/dots.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/dots.vue?vue&type=style&index=0&id=5b0e5f43&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/loaders/dots.vue?vue&type=style&index=0&id=5b0e5f43&lang=css

;// CONCATENATED MODULE: ./src/components/loaders/dots.vue




;


const dots_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(dotsvue_type_script_lang_js, [['render',dotsvue_type_template_id_5b0e5f43_render]])

/* harmony default export */ var dots = (dots_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/circular.vue?vue&type=template&id=3bbb26be

const circularvue_type_template_id_3bbb26be_hoisted_1 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
  class: "loader-circular"
}, null, -1);
const _hoisted_2 = [circularvue_type_template_id_3bbb26be_hoisted_1];
function circularvue_type_template_id_3bbb26be_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    id: "overlay-circular",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'background-color': $data.bgcolors
    })
  }, _hoisted_2, 4);
}
;// CONCATENATED MODULE: ./src/components/loaders/circular.vue?vue&type=template&id=3bbb26be

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/circular.vue?vue&type=script&lang=js

/* harmony default export */ var circularvue_type_script_lang_js = ({
  name: "circular",
  mixins: [overflow],
  props: {
    object: {
      type: String
    },
    color1: {
      type: String
    },
    color2: {
      type: String
    },
    loadingText: {
      type: String
    },
    textColor: {
      type: String
    },
    textSize: {
      type: [String, Number]
    },
    textWeight: {
      type: [String, Number]
    },
    size: {
      type: [String, Number]
    },
    speed: {
      type: [String, Number]
    },
    opacity: {
      type: [String, Number]
    },
    bg: {
      type: String
    },
    objectbg: {
      type: String
    },
    disableScrolling: {
      type: Boolean
    }
  },
  data() {
    return {
      bgcolors: ''
    };
  },
  created() {
    let root = document.documentElement;
    root.style.setProperty('--color-animation1', this.object);
    root.style.setProperty('--color-animation2', this.color1);
    root.style.setProperty('--color-animation3', this.color2);
    root.style.setProperty('--border-size', this.size + 'px solid transparent');
    root.style.setProperty('--time-animation1', "spin-circular " + (this.speed - 0.5) + "s linear infinite");
    root.style.setProperty('--time-animation2', "spin-circular " + this.speed + "s linear infinite");
    root.style.setProperty('--time-animation3', "spin-circular " + (this.speed + 1.0) + "s linear infinite");
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(this.bg)) {
      let c = this.bg.substring(1).split('');
      if (c.length == 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      c = '0x' + c.join('');
      this.bgcolors = 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',' + this.opacity / 100 + ')';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/loaders/circular.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/circular.vue?vue&type=style&index=0&id=3bbb26be&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/loaders/circular.vue?vue&type=style&index=0&id=3bbb26be&lang=css

;// CONCATENATED MODULE: ./src/components/loaders/circular.vue




;


const circular_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(circularvue_type_script_lang_js, [['render',circularvue_type_template_id_3bbb26be_render]])

/* harmony default export */ var circular = (circular_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/toptombar.vue?vue&type=template&id=32471413

const toptombarvue_type_template_id_32471413_hoisted_1 = {
  class: "load-text"
};
function toptombarvue_type_template_id_32471413_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    id: "overlay-bar",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'background-color': $data.bgcolors
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "loader-bar",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'color': $props.object,
      'font-size': $props.size + 'px'
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", toptombarvue_type_template_id_32471413_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)($props.loadingText), 1)], 4)], 4);
}
;// CONCATENATED MODULE: ./src/components/loaders/toptombar.vue?vue&type=template&id=32471413

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/toptombar.vue?vue&type=script&lang=js

/* harmony default export */ var toptombarvue_type_script_lang_js = ({
  name: "toptombar",
  mixins: [overflow],
  props: {
    object: {
      type: String
    },
    color1: {
      type: String
    },
    color2: {
      type: String
    },
    loadingText: {
      type: String
    },
    textColor: {
      type: String
    },
    textSize: {
      type: [String, Number]
    },
    textWeight: {
      type: [String, Number]
    },
    size: {
      type: [String, Number]
    },
    speed: {
      type: [String, Number]
    },
    opacity: {
      type: [String, Number]
    },
    bg: {
      type: String
    },
    objectbg: {
      type: String
    },
    disableScrolling: {
      type: Boolean
    }
  },
  data() {
    return {
      bgcolors: ''
    };
  },
  created() {
    let root = document.documentElement;
    root.style.setProperty('--time-animation', "load " + this.speed + "s infinite alternate ease-in-out");
    root.style.setProperty('--color-bar', this.objectbg);
    root.style.setProperty('--load-text-color', this.textColor);
    root.style.setProperty('--load-text-size', this.textSize + 'px');
    root.style.setProperty('--load-text-weight', this.textWeight);
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(this.bg)) {
      let c = this.bg.substring(1).split('');
      if (c.length == 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      c = '0x' + c.join('');
      this.bgcolors = 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',' + this.opacity / 100 + ')';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/loaders/toptombar.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/toptombar.vue?vue&type=style&index=0&id=32471413&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/loaders/toptombar.vue?vue&type=style&index=0&id=32471413&lang=css

;// CONCATENATED MODULE: ./src/components/loaders/toptombar.vue




;


const toptombar_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(toptombarvue_type_script_lang_js, [['render',toptombarvue_type_template_id_32471413_render]])

/* harmony default export */ var toptombar = (toptombar_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/box.vue?vue&type=template&id=7c8f5ac9

function boxvue_type_template_id_7c8f5ac9_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
    id: "overlay-box",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'background-color': $data.bgcolors
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
    class: "load-box",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
      'background': $props.object,
      'width': $props.size * 20 + 'px',
      'height': $props.size * 20 + 'px'
    })
  }, null, 4)], 4);
}
;// CONCATENATED MODULE: ./src/components/loaders/box.vue?vue&type=template&id=7c8f5ac9

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/box.vue?vue&type=script&lang=js

/* harmony default export */ var boxvue_type_script_lang_js = ({
  name: "box",
  mixins: [overflow],
  props: {
    object: {
      type: String
    },
    color1: {
      type: String
    },
    color2: {
      type: String
    },
    loadingText: {
      type: String
    },
    textColor: {
      type: String
    },
    textSize: {
      type: [String, Number]
    },
    textWeight: {
      type: [String, Number]
    },
    size: {
      type: [String, Number]
    },
    speed: {
      type: [String, Number]
    },
    opacity: {
      type: [String, Number]
    },
    bg: {
      type: String
    },
    objectbg: {
      type: String
    },
    disableScrolling: {
      type: Boolean
    }
  },
  data() {
    return {
      bgcolors: ''
    };
  },
  created() {
    let root = document.documentElement;
    root.style.setProperty('--time-animation', "loading " + this.speed + "s linear infinite");
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(this.bg)) {
      let c = this.bg.substring(1).split('');
      if (c.length == 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      c = '0x' + c.join('');
      this.bgcolors = 'rgba(' + [c >> 16 & 255, c >> 8 & 255, c & 255].join(',') + ',' + this.opacity / 100 + ')';
    }
  }
});
;// CONCATENATED MODULE: ./src/components/loaders/box.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loaders/box.vue?vue&type=style&index=0&id=7c8f5ac9&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/loaders/box.vue?vue&type=style&index=0&id=7c8f5ac9&lang=css

;// CONCATENATED MODULE: ./src/components/loaders/box.vue




;


const box_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(boxvue_type_script_lang_js, [['render',boxvue_type_template_id_7c8f5ac9_render]])

/* harmony default export */ var box = (box_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-82.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loader.vue?vue&type=script&lang=js





/* harmony default export */ var loadervue_type_script_lang_js = ({
  name: 'loader',
  components: {
    spinning: loader1,
    dots: dots,
    circular: circular,
    loading: toptombar,
    box: box
  },
  props: {
    object: {
      type: String,
      default: '#ff9633'
    },
    color1: {
      type: String,
      default: '#ffffff'
    },
    color2: {
      type: String,
      default: '#17fd3d'
    },
    loadingText: {
      type: String,
      default: 'LOADING...'
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    textSize: {
      type: [String, Number],
      default: 15
    },
    textWeight: {
      type: [String, Number],
      default: 800
    },
    size: {
      type: [String, Number],
      default: 5
    },
    speed: {
      type: [String, Number],
      default: 2
    },
    opacity: {
      type: [String, Number],
      default: 80
    },
    bg: {
      type: String,
      default: '#343a40'
    },
    objectbg: {
      type: String,
      default: '#999793'
    },
    name: {
      type: String,
      default: 'spinning'
    },
    disableScrolling: {
      type: Boolean,
      default: false
    }
  }
});
;// CONCATENATED MODULE: ./src/components/loader.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-54.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-54.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-54.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/loader.vue?vue&type=style&index=0&id=1a3e84c0&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/loader.vue?vue&type=style&index=0&id=1a3e84c0&lang=css

;// CONCATENATED MODULE: ./src/components/loader.vue




;


const loader_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(loadervue_type_script_lang_js, [['render',render]])

/* harmony default export */ var loader = (loader_exports_);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (loader);


}();
__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=loader.umd.js.map